import { token } from './storage'
import { logout as ptLogout } from '@pt/api/adv'
import { sendLogoutLog } from '@pt/utils/log'

export function getToken() {
  return token.get()
}

// 单独加这个能力，是为了区分`getToken`，因为之前的获取token的逻辑不符合视频编辑器的需要
export function getTokenWhitCookie() {
  return token.getOnlyCookie()
}

export function setToken(val) {
  token.set(val)
}

export function removeToken() {
  token.remove()
}

export const logout = async (option) => {
  const logoutCallback = () => {
    removeToken()
    // 跳转到首页
    window.location = '/'
  }

  if (option && option.type !== undefined) {
    sendLogoutLog({ type: option.type, msg: option.msg || '' })
  }

  if (getToken()) {
    await ptLogout()
    logoutCallback()
  } else {
    logoutCallback()
  }
}
